import { observable, action } from 'mobx';

class PassiveAccumulationStore {
  @observable agentGroup = '';
  @observable summaryInfoMap: Record<string, any> = {};

  @action
  setAgentGroup(data: string) {
    this.agentGroup = data || '';
  }

  @action
  setSummaryInfoMap(data: Record<string, any>) {
    this.summaryInfoMap = data;
  }
}

export default new PassiveAccumulationStore();
